import React from "react";
import { Box, Typography } from "@mui/material";
import { useAppDispatch } from "../../../../hooks/useRedux";
import { changeSignupCompanyStep } from "../../../../redux/features/settingSlice";

interface Props {
  data: {
    title: string;
    index: number;
    status: "active" | "inActive" | "done";
    step: "CompanyInfo" | "ManagerInfo" | "ApproveInfo";
  };
  chnageStep?: (step: number) => void;
}

export default function StepItem({ data }: Props) {
  const dispatch = useAppDispatch();
  return (
    <Box
      onClick={() => dispatch(changeSignupCompanyStep(data.step))}
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "8px",
      }}
    >
      <Box
        sx={{
          width: "28px",
          height: "28px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "50%",
          backgroundColor:
            data.status === "done"
              ? "success.main"
              : data.status === "active"
              ? "secondary.main"
              : "info.main",
        }}
      >
        <Typography sx={{ fontSize: "18px", color: "background.default" }}>
          {data.index}
        </Typography>
      </Box>
      <Typography
        sx={{
          color:
            data.status === "done"
              ? "success.main"
              : data.status === "active"
              ? "secondary.main"
              : "info.main",
          fontSize: "12px",
          fontWeight: data.status === "active" ? "600" : "400",
        }}
      >
        {data.title}
      </Typography>
    </Box>
  );
}
